// Generated by ReScript, PLEASE EDIT WITH CARE


function getRnrHome(param) {
  return {
          pointsSectionTitle: "Total Reward Points",
          pointsSectionSubtitle: "Reach new levels and win exciting gifts",
          dailyRewardsHeader: "Daily Rewards",
          cardCtaText: "Tap to Claim",
          allRewardsClaimedTitle: "Congrats",
          allRewardsClaimedText: "You have claimed all the rewards",
          noRewardsClaimedTitle: "You have no rewards now",
          noRewardsClaimedText: "Please check back tomorrow",
          rewardHistoryFooterText: "Rewards and Gifts History",
          headerText: "Porter Reward Program"
        };
}

function getMilestoneDetails(vehicleModel) {
  return {
          headerTitle: "Win a " + vehicleModel,
          headerDetails: "The partner with highest reward points will win this great new truck",
          claimedText: "Reward claimed",
          toClaimText: "Claim your reward",
          footerText: "More levels will unlock as you progress",
          milestone1: "Star",
          milestone2: "Bronze Hero",
          milestone3: "Bronze Super Star",
          milestone4: "Silver Hero",
          milestone5: "Silver Superstar",
          milestone6: "Platinum Hero",
          milestone7: "Platinum Superstar",
          milestone8: "Gold Hero",
          milestone9: "Gold Superstar",
          milestone10: "Diamond Hero",
          milestone11: "Diamond Super Star",
          milestone12: "Porter Hero",
          milestone13: "Supro Super Star",
          locked: "Locked"
        };
}

function getRnrCycleEnd(param) {
  return {
          greetings: "Congratulations",
          winLabel: "You have won a",
          winNotice: "We will call and inform you on how to collect the prize",
          lossNotice: "Sorry. You have not won any prize this time. Please participate better in the next cycle to win prize.",
          endTitle: "Porter Reward Program has ended.",
          endText: "Next cycle will be announced soon.",
          scoreTitle: "Here is how you performed",
          totalScoreSubtext: "Total Points accumulated",
          customerExperienceScoreSubtext: "for Customer Experience",
          orderCompletionScoreSubtext: "for Order Completion",
          loginActivityScoreSubtext: "for Login activity",
          topGiftsTitle: "Here are some of the top rewards",
          topPartnersTitle: "Here are some of our top partners",
          partnerName: "Partner Name",
          awardTitle: "Award Won"
        };
}

function getContent(param) {
  return {
          rnrHome: getRnrHome(undefined),
          rnrHistory: {
            title: "Rewards",
            yesterdayRowTitle: "Yesterday",
            rewardNavTabTitle: "Daily Rewards",
            awardNavTabTitle: "Level Gifts"
          },
          milestoneDetails: getMilestoneDetails("Mahindra"),
          customerServiceRewards: {
            text1: "You Earned",
            text2: "For Good Customer Service"
          },
          loginActivtyRewards: {
            text1: "You Earned",
            text2: "Login Activity"
          },
          orderFulfillmentRewards: {
            text1: "You Earned",
            text2: "For completing all accepted orders"
          },
          mahindraAwards: {
            cardTitle: "Win a Mahindra",
            cardText: "Tap to know more",
            modalTitle: "Win a Mahindra",
            modalText: "Win exciting gifts every month and a grand prize of Mini Truck. Keep checking your points to know more."
          },
          defaultLCVAward: {
            modalTitle: "Get a chance to win bumper prize and other exciting prizes this Diwali!",
            modalText: ""
          },
          defaultHCVAward: {
            modalTitle: "Get a chance to win bumper prize and other exciting prizes this Diwali!",
            modalText: ""
          },
          default2WAward: {
            modalTitle: "Win Exciting Prizes Every Week",
            modalText: ""
          },
          noAward: {
            cardTitle: "Reach next milestone faster to get a Prize!",
            cardText: "Tap to know more",
            modalTitle: "Reach next milestone faster to get a Prize!",
            modalText: "The prizes you are eligible for have been claimed by other partners. Please reach next milestone faster than others to claim a prize."
          },
          insuranceAward: {
            cardTitle: "You have won discount on vehicle Insurance",
            modalTitle: "Hurray! You have won discount on vehicle Insurance"
          },
          distributionCeremonyAward: {
            cardTitle: "You stand a chance to win attractive prizes from Porter",
            cardText: "Top performing partners will get a chance to win attractive prizes.  T&C applied",
            modalTitle: "You stand a chance to win attractive prizes from Porter",
            modalText: "Top performing partners will get a chance to win attractive prizes. T&C applied"
          },
          finalAward: {
            cardTitle: " You stand a chance to win a \"Mini Truck\" vehicle from Porter",
            cardText: "One top performing partner across India will win",
            modalTitle: " You stand a chance to win a \"Mini Truck\" vehicle from Porter",
            modalText: "One top performing partner across India will win. Winner will be announced towards the end of the program. T&C applied"
          },
          couponAward: {
            couponText: "Coupon",
            redeemTitle: "Steps to Redeem",
            detailsText: "Details",
            tncText: "Terms and Conditions",
            codeAckTitle: "Coupon Code Copied"
          },
          status: {
            loading: "Loading",
            internetNotConnected: "Internet Not Connected",
            tapToRetry: "Tap To Retry",
            ise: "Something Went Wrong",
            loadingFailed: "Loading Failed"
          },
          category: {
            customerService: "Customer Service",
            loginHours: "Login Activity",
            orderFulfillment: "Completed Orders"
          },
          customerServiceDetails: {
            details1: "Your Customer Service points increase when you get\n                5 star ratings from customers for your orders.",
            details2: "So, increase the number of 5 star rating orders you do.",
            sectionHeader: "How to get 5 star ratings?",
            tip1: "Always respect and be polite with the customers",
            tip2: "Never argue with customers. Take assistance from call center in case of disputes",
            tip3: "Handle customer goods with care"
          },
          loginHourDetails: {
            details1: "More you stay online, more Login Activity points you get.",
            tips: "Tips",
            tip: "Utilize your free time to give maximum hours to earn more"
          },
          orderFulfillmentDetails: {
            details1: "How can I earn completed orders points ?",
            details2: "Only accept the orders which you wish to fulfill.",
            tip1: "Do not cancel any order after accepting the order",
            tip2: "Never ask customer to cancel the order",
            slabTableText: "Below table shows points per completed order",
            slabTableCol1: "Completed Orders",
            slabTableCol2: "Points"
          },
          miscellaneous: {
            points: "points"
          },
          rnrCycleEnd: getRnrCycleEnd(undefined),
          getExpiryDateTitle: (function (date) {
              return "Expires by " + date;
            }),
          getExpiringDateTitle: (function (date) {
              return "Expiring on " + date;
            }),
          getExpiryHoursTitle: (function (hours) {
              return "Expires in " + hours + " hours";
            }),
          getCurrentMilestoneText: (function (currentMilestone) {
              return "You're a " + currentMilestone;
            }),
          getNextMilestoneText: (function (points, nextMilestone) {
              return "" + points + " more to become a " + nextMilestone;
            }),
          getCustomerServiceRewardsText: (function (qualifiedOrders) {
              return " " + qualifiedOrders + " Five Star Trips ";
            }),
          getOrderFulfillmentRewardsText: (function (completedOrders, _requiredOrders) {
              return " You completed " + completedOrders + " orders";
            }),
          getLoginActivtyRewardsText: (function (loginHours) {
              return " Rewarded Login Hours " + loginHours + " ";
            }),
          getLoginRewardsDetailsText: (function (points) {
              return "You have " + points + " login activity points";
            }),
          getCustomerServiceRewardsDetailsText: (function (points) {
              return "You have " + points + " customer service points";
            }),
          getNextMilestoneSubText: (function (points) {
              return " " + points + " points away ";
            }),
          getCustomerServicePer5StarOrderPoints: (function (points) {
              return " You get " + points + " points for each 5 star order ";
            }),
          getLoginHourRewardsDetailsText: (function (startTime, endTime) {
              return "Your Login Activity point increases when you stay online on Porter App between " + startTime + " to " + endTime;
            }),
          getLoginHourRewardsLoginWindowTip: (function (startTime, endTime) {
              return "Try and be online more between " + startTime + " to " + endTime;
            }),
          getLoginHourRewardsPerHourPointsTip: (function (points) {
              return " Every hour logged in has " + points + " points. Longer hours equals more points ";
            }),
          getOrderFullfillmentRewardsDetailsText: (function (points) {
              return "You have " + points + " completed orders points";
            }),
          getOrderFullfillmentDailyMaxPointsTip: (function (points) {
              return "You can earn only " + points + " points per day";
            }),
          getMilestonePointsRemaining: (function (points) {
              return " " + points + " more points needed ";
            }),
          getLastSlabText: (function (orders) {
              return " " + orders + " or more ";
            }),
          getFuelAwardCardTitle: (function (fuelQuantity) {
              return " You won " + fuelQuantity + " litres of fuel ";
            }),
          getFuelAwardCardText: (function (fuelMoney) {
              return " INR " + fuelMoney + " is credited in your wallet ";
            }),
          getFuelAwardModalTitle: (function (fuelQuantity) {
              return " Hurray! You have won " + fuelQuantity + " litres of fuel ";
            }),
          getFuelAwardModalText: (function (fuelMoney) {
              return " An equivalent amount of INR " + fuelMoney + " has been credited in your wallet. ";
            }),
          getPremiumnessAwardCardTitle: (function (acceptAdvantage) {
              return " No " + acceptAdvantage + " seconds delay during orders! ";
            }),
          getPremiumnessAwardCardText: (function (acceptAdvantage, endDate) {
              return " You won't face " + acceptAdvantage + " seconds delay during orders anymore till " + endDate + " ";
            }),
          getPremiumnessAwardModalTitle: (function (acceptAdvantage) {
              return " No " + acceptAdvantage + " seconds delay during orders! ";
            }),
          getPremiumnessAwardModalText: (function (acceptAdvantage, startDate, endDate) {
              return " You have won the Porter Premium Partner award. You won't face " + acceptAdvantage + " seconds delay during the below mentioned dates in orders anymore.\n      Star Date - " + startDate + "\n      End date - " + endDate + " ";
            }),
          getMonetaryAwardCardTitle: (function (amount) {
              return " You have won ₹ " + amount + " ";
            }),
          getMonetaryAwardCardText: (function (amount) {
              return " The winning prize of ₹ " + amount + " has been credited in the wallet. ";
            }),
          getMonetaryAwardModalTitle: (function (amount) {
              return " Hurray! You have won INR " + amount + " ";
            }),
          getMonetaryAwardModalText: (function (amount) {
              return " The winning prize of ₹ " + amount + " has been credited in the wallet. ";
            }),
          getInsuranceAwardCardText: (function (price, endDate) {
              return " You can collect the Insurance from Porter at ₹" + price + " only!! Valid till " + endDate + ".";
            }),
          getInsuranceAwardModalText: (function (price, endDate) {
              return " You can collect the Insurance from Porter at ₹" + price + " only!! The award is valid till " + endDate + ".";
            }),
          getInsuranceAwardCardDiscountText: (function (discount, endDate) {
              return " You won a discount of ₹" + discount + " on vehicle Insurance from Porter!! Valid till " + endDate + ".";
            }),
          getInsuranceAwardModalDiscountText: (function (discount, endDate) {
              return " You won a discount of ₹" + discount + " on vehicle Insurance from Porter!! Valid till " + endDate + ".";
            }),
          getRewardMultiplierAwardCardTitle: (function (multiplier) {
              return " You will win " + multiplier + " reward points";
            }),
          getRewardMultiplierAwardCardText: (function (multiplier, startDate, endDate) {
              return " From " + startDate + ", all categories will give you " + multiplier + " reward points. Valid till " + endDate;
            }),
          getRewardMultiplierAwardModalTitle: (function (multiplier) {
              return " Hurray! You will win " + multiplier + " reward points ";
            }),
          getRewardMultiplierAwardModalText: (function (multiplier, startDate, endDate) {
              return " From " + startDate + ", all categories will give you " + multiplier + " reward points. Valid till " + endDate;
            }),
          getTopGiftCardSubtext: (function (recipient_cnt) {
              return " Awarded to " + recipient_cnt + " partners ";
            })
        };
}

var English = {
  getContent: getContent
};

export {
  English ,
  
}
/* No side effect */
